export const pdpa = {
    terms_title: 'Terms & Conditions',
    privacy_title: 'Privacy policy',
    mkt_title: 'Marketing message',
    btn_accept: 'ยอมรับ',
    allow_channel: 'ฉันสนใจและต้องการรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆ ที่เกี่ยวข้องจาก ShopDD และ ผลิตภัณฑ์จากบริษัทในเครือ บริษัท บัซซี่บีส์ จำกัด กรุณาเลือกอย่าง 1 ช่องทาง',
    checkbox_email: 'อีเมล์',
    checkbox_sms: 'ข้อความสั้น (SMS)',
    mkt_confirm_title: 'If don’t agree marketing consent',
    mkt_confirm_msg: 'You will lose some information and it privilege',
    btn_skip: 'Skip',
    btn_back: 'Back to Setting',
}
